import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ta from './ta.json'
import en from './en.json'
import de from './de.json'

const resources = { 
  ta: { translation: ta }, 
  en: { translation: en },
  de: { translation: de }
} as const

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ta',
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  })

export default i18n

